export function getChatGroupLabel(date: Date): string {
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const input = new Date(date);
  input.setHours(0, 0, 0, 0);

  const diffDays = Math.floor(
    (today.getTime() - input.getTime()) / (1000 * 60 * 60 * 24)
  );

  if (diffDays === 0) return 'Today';
  if (diffDays === 1) return 'Yesterday';
  if (diffDays <= 7) return 'Last 7 Days';
  if (diffDays <= 30) return 'Last 30 Days';

  return input.toLocaleDateString(undefined, {
    year: 'numeric',
    month: 'long',
  });
}
